import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="depot-steuerzuordnung"
export default class extends Controller {
	static targets = ["select", "gewerblich", "infoText"]

	connect() {
		this.updateSteuerzuordnung()
	}

	updateSteuerzuordnung() {
		const selectedValue = this.selectTarget.value

		this.infoTextTargets.forEach((el) => {
			el.classList.toggle("hidden", el.dataset.value !== selectedValue)
		})

		if (this.hasGewerblichTarget) {
			const showGewerblich = selectedValue === "pg_gewerblich" || selectedValue === "kapitalgesellschaft"
			this.gewerblichTarget.classList.toggle("hidden", !showGewerblich)
		}
	}
}
